export default __webpack_public_path__ + "static/media/ksivalue_main_large.7b61e179.jpg";